import MuiTooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const Tooltip = styled(({ className, ...props }: TooltipProps) => (
	<MuiTooltip arrow placement='left' {...props} classes={{ popper: className }} />
))(({ color }: TooltipProps) => ({
	[`& .${tooltipClasses.arrow}`]: {
		color: color,
	},
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: color,
	},
}));

export default Tooltip;
